import { render, staticRenderFns } from "./FormUserRoleUserList.vue?vue&type=template&id=24e3154a&scoped=true&"
import script from "./FormUserRoleUserList.vue?vue&type=script&lang=js&"
export * from "./FormUserRoleUserList.vue?vue&type=script&lang=js&"
import style0 from "./FormUserRoleUserList.vue?vue&type=style&index=0&id=24e3154a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3154a",
  null
  
)

export default component.exports